import { c as _c } from "react/compiler-runtime";
import React, { useState, useMemo, useCallback } from 'react';
import BrowserOnly from 'components/consumer/BrowserOnly';
import UpdateZipcodeSidebar from 'components/consumer/UpdateZipcodeSidebar';
import useZipCode from 'global-state/zipCode/useZipCode';
import useIsZipCodeFromUserServiceable from 'global-state/isZipCodeFromUserServiceable/useIsZipCodeFromUserServiceable';
import useZipCodeFromUser from 'global-state/zipCodeFromUser/useZipCodeFromUser';
import useUserLocation from 'global-state/userLocation/useUserLocation';
import useUserLocationLoading from 'global-state/userLocationLoading/useUserLocationLoading';
import PDPZipCodeEditLocationUI from './PDPZipCodeEditLocationUI';
const PDPZipCodeEditLocation = () => {
  const $ = _c(15);
  const zipCode = useZipCode();
  const zipCodeFromUser = useZipCodeFromUser();
  const userLocation = useUserLocation();
  const isLocationLoading = useUserLocationLoading();
  const [isUpdateZipcodeOpen, setIsUpdateZipcodeOpen] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setIsUpdateZipcodeOpen(_temp);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const toggleUpdateZipCodeSidebar = t0;
  const {
    address: locationAddress,
    city: locationCity,
    country: locationCountry,
    state: locationState,
    stateShortName: locationStateShortName
  } = userLocation;
  const isUserInUS = locationCountry === "United States";
  let t1;
  bb0: {
    if (locationState) {
      t1 = `${locationCity ? `${locationCity}, ${locationStateShortName || locationState}` : `${locationStateShortName || locationState}`}`;
      break bb0;
    }
    let t2;
    if ($[1] !== locationAddress || $[2] !== zipCode) {
      t2 = locationAddress?.replace("United States", "US") || zipCode;
      $[1] = locationAddress;
      $[2] = zipCode;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    t1 = t2;
  }
  const locationToShow = t1;
  const isZipCodeFromUserServiceable = useIsZipCodeFromUserServiceable();
  let t2;
  if ($[4] !== isUpdateZipcodeOpen) {
    t2 = <BrowserOnly><UpdateZipcodeSidebar isZipcodeFormOpen={isUpdateZipcodeOpen} onClose={toggleUpdateZipCodeSidebar} /></BrowserOnly>;
    $[4] = isUpdateZipcodeOpen;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== isLocationLoading || $[7] !== isUserInUS || $[8] !== isZipCodeFromUserServiceable || $[9] !== locationToShow || $[10] !== zipCodeFromUser) {
    t3 = <PDPZipCodeEditLocationUI isLoading={isLocationLoading} isUserInUS={isUserInUS} isZipCodeFromUserServiceable={isZipCodeFromUserServiceable} locationToShow={locationToShow} toggleUpdateZipCodeSidebar={toggleUpdateZipCodeSidebar} zipCodeFromUser={zipCodeFromUser} />;
    $[6] = isLocationLoading;
    $[7] = isUserInUS;
    $[8] = isZipCodeFromUserServiceable;
    $[9] = locationToShow;
    $[10] = zipCodeFromUser;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== t2 || $[13] !== t3) {
    t4 = <>{t2}{t3}</>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
};
export default React.memo(PDPZipCodeEditLocation);
function _temp(prevIsUpdateZipcodeOpen) {
  return !prevIsUpdateZipcodeOpen;
}